import React, { createContext, useState, useContext, useEffect } from "react";
import {jwtDecode} from "jwt-decode"; // Make sure this is imported correctly

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [uid, setUid] = useState(null);
  const [role, setRole] = useState(null);
  const [memberid, setmemberid] = useState(null);
  
  useEffect(() => {
    const checkToken = () => {
      const storedToken = localStorage.getItem('token');
      if (storedToken) {
        try {
          const { exp, ...decodedToken } = jwtDecode(storedToken);
          const expirationTime = new Date((exp * 1000)+ (60 *60*1000));
          const currentTime = new Date();
          
          if (expirationTime > currentTime) {
            setIsAuthenticated(true);
            setToken(storedToken);
            setUid(decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]);
            setRole(decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]);
          } else {
            logout();
          }
        } catch {
          logout();
        }
      }
    };

    checkToken();
  }, []);

  const login = (newToken) => {
    try {
      const { exp, ...decodedToken } = jwtDecode(newToken);
      setmemberid(decodedToken.memberId);
      // console.log(decodedToken);
      
      const expirationTime = new Date(exp * 1000);
      const currentTime = new Date();
      if (expirationTime > currentTime) {
        setIsAuthenticated(true);
        setToken(newToken);
        localStorage.setItem('token', newToken);
        setUid(decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]);
        setRole(decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]);
      } else {
        logout();
      }
    } catch {
      logout();
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setToken(null);
    setUid(null);
    setRole(null);
    localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, uid, role, login, logout,memberid }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);